// extracted by mini-css-extract-plugin
module.exports = {"container":"Popup_container__3ZvmB"};